/* eslint-disable react/prop-types */
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { makeNiceText } from "utils/formatters";

const getRowsMenu = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        producto: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h6" fontWeight="bold" color="dark">
              {item?.nombre ? makeNiceText(item?.nombre) : "Sin datos"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidad: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h6">
              {item?.cantidad ? item?.cantidad : "Sin datos"}
            </SoftTypography>
          </SoftBox>
        ),

        hasBorder: true,
      });
    });
  }

  return rows;
};

const columnsMenu = [
  { name: "producto", desc: "Descripción", align: "left" },
  { name: "cantidad", desc: "A entregar", align: "center", noOrder: true },
];

export default { columnsMenu, getRowsMenu };
